import { useAppSelector } from "~/redux/store/store";

export const useIsMobile = () => {
  const isMobile = useAppSelector((s) => s.general.isMobile);
  return isMobile;
};
